export const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit * 2,
    overflowX: 'auto',
  },
  disabled: { 
    opacity: 0.3,
    pointerEvents: 'none'
  }
})



// WEBPACK FOOTER //
// ./src/components/Bookings/styles.js